import useEntities from 'new/state/entities/repository/useEntities';
import useSinksAdapter from 'new/state/sinks/adapter/useSinksAdapter';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_SINK_REQUEST } from 'js/constants/actionTypes';
import { useEffect } from 'react';
import { FlowTriggerEventType } from 'js/components/data_sources/add_ds_form/MonitoringInterval/FlowTriggerHelper';
import { Resource, Resources } from '@nexla/@types';
import useSourcesAdapter from 'new/state/sources/adapter/useSourcesAdapter';

interface UseFlowTrigger {
  sources: Resources;
  sinks: Resources;
  loading: boolean;
}

export function useFlowTrigger(source: Resource): UseFlowTrigger {
  const { data: sinks } = useEntities('sinks');
  const { data: sources } = useEntities('sources');
  const { getSinkById } = useSinksAdapter();
  const { getSourceById } = useSourcesAdapter();
  const loading = useIsLoading(GET_SINK_REQUEST);

  useEffect(() => {
    /**
     * if the user land in the edit page by URL, the source and sinks entities will be empty
     */
    (async () => {
      if (Array.isArray(sinks) && Object.values(sinks).length === 0) {
        const triggerType = source?.flow_triggers[0];
        if (triggerType?.triggering_event_type === FlowTriggerEventType.SINK) {
          await getSinkById(triggerType.triggering_resource_id);
        }

        if (triggerType?.triggering_event_type === FlowTriggerEventType.SOURCE) {
          await getSourceById(triggerType.triggering_resource_id);
        }
      }

      if (Array.isArray(source) && Object.values(sources).length === 0) {
        const triggerType = source?.flow_triggers[0];
        if (triggerType?.triggering_event_type === FlowTriggerEventType.SOURCE) {
          await getSourceById(triggerType.triggering_resource_id);
        }
      }
    })();
  }, []);

  return {
    sinks,
    sources,
    loading,
  };
}
